// extracted by mini-css-extract-plugin
export default {"content":"src-signer-app-signer-experience-access-code-module__content--2ODql","instructionText":"src-signer-app-signer-experience-access-code-module__instructionText--1hmBM"};